module.exports = __webpack_public_path__ + "static/media/วอก.fb3d5c48.png";